// Theme: winter-solstice
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'winter-solstice',
  name: 'WINTER SOLSTICE',
  tagline: 'WINTER SOLSTICE',
  description: 'Ciano cristalino de aurora artica em assinatura solstice.',
  category: 'organic-world',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#051014', '#0A1F2A', '#67E8F9', '#CFFAFE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-winter-solstice'
  },
  colorVars: {
    '--accent': '#67E8F9',
    '--accent-foreground': '#051014',
    '--background': '#051014',
    '--border': '#1A5A7A',
    '--card': '#0A1F2A',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#CFFAFE',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#051014',
    '--foreground': '#CFFAFE',
    '--hold-fill': '#67E8F9',
    '--input': '#1A5A7A',
    '--modal-bg': '#051014',
    '--modal-border': '#1A5A7A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#1A5A7A',
    '--muted-foreground': '#CFFAFE',
    '--nav-active': '#67E8F9',
    '--nav-bg': '#0A1F2A',
    '--popover': '#0A1F2A',
    '--popover-foreground': '#CFFAFE',
    '--primary': '#67E8F9',
    '--primary-foreground': '#051014',
    '--ring': '#67E8F9',
    '--secondary': '#1A5A7A',
    '--secondary-foreground': '#CFFAFE',
    '--streak': '#67E8F9',
    '--success': '#22c55e',
    '--success-foreground': '#051014',
    '--xp': '#67E8F9',
    '--xp-bg': '#0A1F2A'
  },
  resolvedVars: {
    '--accent': '#67E8F9',
    '--accent-foreground': '#051014',
    '--accent-foreground-hsl': '196 60% 5%',
    '--accent-foreground-oklch': 'from #051014 l c h',
    '--accent-hsl': '187 92% 69%',
    '--accent-oklch': 'from #67E8F9 l c h',
    '--background': '#051014',
    '--background-hsl': '196 60% 5%',
    '--background-oklch': 'from #051014 l c h',
    '--border': '#1A5A7A',
    '--border-hsl': '200 65% 29%',
    '--border-oklch': 'from #1A5A7A l c h',
    '--border-w': '1px',
    '--card': '#0A1F2A',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#CFFAFE',
    '--card-foreground-hsl': '185 96% 90%',
    '--card-foreground-oklch': 'from #CFFAFE l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '201 62% 10%',
    '--card-oklch': 'from #0A1F2A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#051014',
    '--destructive-foreground-hsl': '196 60% 5%',
    '--destructive-foreground-oklch': 'from #051014 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#CFFAFE',
    '--foreground-hsl': '185 96% 90%',
    '--foreground-oklch': 'from #CFFAFE l c h',
    '--hold-fill': '#67E8F9',
    '--hold-fill-hsl': '187 92% 69%',
    '--hold-fill-oklch': 'from #67E8F9 l c h',
    '--input': '#1A5A7A',
    '--input-hsl': '200 65% 29%',
    '--input-oklch': 'from #1A5A7A l c h',
    '--modal-bg': '#051014',
    '--modal-bg-hsl': '196 60% 5%',
    '--modal-bg-oklch': 'from #051014 l c h',
    '--modal-border': '#1A5A7A',
    '--modal-border-hsl': '200 65% 29%',
    '--modal-border-oklch': 'from #1A5A7A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#1A5A7A',
    '--muted-foreground': '#CFFAFE',
    '--muted-foreground-hsl': '185 96% 90%',
    '--muted-foreground-oklch': 'from #CFFAFE l c h',
    '--muted-hsl': '200 65% 29%',
    '--muted-oklch': 'from #1A5A7A l c h',
    '--nav-active': '#67E8F9',
    '--nav-active-hsl': '187 92% 69%',
    '--nav-active-oklch': 'from #67E8F9 l c h',
    '--nav-bg': '#0A1F2A',
    '--nav-bg-hsl': '201 62% 10%',
    '--nav-bg-oklch': 'from #0A1F2A l c h',
    '--popover': '#0A1F2A',
    '--popover-foreground': '#CFFAFE',
    '--popover-foreground-hsl': '185 96% 90%',
    '--popover-foreground-oklch': 'from #CFFAFE l c h',
    '--popover-hsl': '201 62% 10%',
    '--popover-oklch': 'from #0A1F2A l c h',
    '--primary': '#67E8F9',
    '--primary-foreground': '#051014',
    '--primary-foreground-hsl': '196 60% 5%',
    '--primary-foreground-oklch': 'from #051014 l c h',
    '--primary-hsl': '187 92% 69%',
    '--primary-oklch': 'from #67E8F9 l c h',
    '--radius': '12px',
    '--ring': '#67E8F9',
    '--ring-hsl': '187 92% 69%',
    '--ring-oklch': 'from #67E8F9 l c h',
    '--secondary': '#1A5A7A',
    '--secondary-foreground': '#CFFAFE',
    '--secondary-foreground-hsl': '185 96% 90%',
    '--secondary-foreground-oklch': 'from #CFFAFE l c h',
    '--secondary-hsl': '200 65% 29%',
    '--secondary-oklch': 'from #1A5A7A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#67E8F9',
    '--streak-hsl': '187 92% 69%',
    '--streak-oklch': 'from #67E8F9 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#051014',
    '--success-foreground-hsl': '196 60% 5%',
    '--success-foreground-oklch': 'from #051014 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(187 92% 69% / 0.15)',
    '--xp': '#67E8F9',
    '--xp-bg': '#0A1F2A',
    '--xp-bg-hsl': '201 62% 10%',
    '--xp-bg-oklch': 'from #0A1F2A l c h',
    '--xp-hsl': '187 92% 69%',
    '--xp-oklch': 'from #67E8F9 l c h'
  }
}
